module.exports = __webpack_public_path__ + "static/find-team-members-874168ccdad4eb4978d340f0f02c7bc9.gif";